/**
 * 带吸附功能的block
 */
import React from 'react';
import { FixedBlockProps } from './interfaces';
import { isInViewport } from '../dom';
import { debounce } from '../func-perf';
import eventManager from '@alife/scc-event-manager/event-manager';

export default class FixedBlock extends React.PureComponent<
  FixedBlockProps,
  {
    fixed: boolean;
  }
> {
  state = {
    fixed: false,
  };

  $container: HTMLElement;
  containerWidth: number;
  containerHeight: number;

  constructor(props) {
    super(props);

    this.__scrollHandler = debounce(this.__scrollHandler, 100);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.__scrollHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.__scrollHandler);
  }

  __scrollHandler = () => {
    let isFixed = true;
    if (!isInViewport(this.$container, { ratio: 0.01 })) {
      this.setState({
        fixed: true,
      });
    } else {
      this.setState({
        fixed: false,
      });
      isFixed = false;
    }
    eventManager.trigger('floatSideActionChange', isFixed);
  };

  render() {
    const {
      id,
      className,
      style,
      dataProps,
      children,
      fixedWhenOutview,
    } = this.props;
    const { fixed } = this.state;
    return (
      <div
        id={id}
        className={className}
        style={{
          ...style,
          width: fixed ? this.containerWidth : undefined,
          height: fixed ? this.containerHeight : undefined,
        }}
        {...dataProps}
        ref={dom => {
          this.$container = dom;
          if (dom) {
            this.containerWidth = dom.offsetWidth;
            this.containerHeight = dom.offsetHeight;
          }
        }}
      >
        <div
          className="fixed-block-inner"
          style={{
            position: fixed ? 'fixed' : 'relative',
            top: fixedWhenOutview.top,
            left: fixedWhenOutview.left,
            right: fixedWhenOutview.right,
          }}
        >
          {children}
        </div>
      </div>
    );
  }
}
